import type { ItineraryData } from "~/components/engage/DualPriceStickyBar/contract";
import { TransportType } from "~/generated/graphql";
import { PAGE_TRACKING } from "~/tools/getTrackingCategoryName";

export enum PRICE_SELECTION_TYPE {
  PRIME = "prime_",
  NON_PRIME = "",
}

interface TrackOnContinueButtonClickProps {
  itineraryData: ItineraryData;
  wasSelectedPrimePrice: boolean;
}

export interface TrackingFunctions {
  trackOnContinueButtonClick: ({
    itineraryData,
    wasSelectedPrimePrice,
  }: TrackOnContinueButtonClickProps) => void;
}

export const getPriceSelectionLabel = (
  wasSelectedPrimePrice: boolean,
): string =>
  wasSelectedPrimePrice
    ? PRICE_SELECTION_TYPE.PRIME
    : PRICE_SELECTION_TYPE.NON_PRIME;

export const getLabelY = (hasTrain: boolean, hasFlight: boolean): string => {
  if (!hasTrain) {
    return "flight";
  }

  if (hasFlight) {
    return "xfaring";
  }

  return "train";
};

export const getLabelS = (
  isMultiDestination: boolean,
  isRoundTrip: boolean,
): string => {
  if (isMultiDestination) {
    return "MD";
  }
  if (isRoundTrip) {
    return "RT";
  }
  return "OW";
};

export const CATEGORY = PAGE_TRACKING.FLIGHTS_SUMMARY;
export const ACTION = "continue_button";
export const LABEL = {
  trackOnContinueButtonClick: ({
    itineraryData,
    wasSelectedPrimePrice,
  }): string => {
    const hasFlight = itineraryData.transportTypes.includes(
      TransportType.Plane,
    );
    const hasTrain = itineraryData.transportTypes.includes(TransportType.Train);
    return `${getPriceSelectionLabel(wasSelectedPrimePrice)}sum_cont_p:${getLabelY(
      hasTrain,
      hasFlight,
    )}_ppos:1_rpos:1_label:0_tab:_type:${getLabelS(
      itineraryData.isMultiDestination,
      itineraryData.isRoundTrip,
    )}_vp:0`;
  },
};

export const tracking = {
  CATEGORY,
  ACTION,
  LABEL,
};

export const getTrackingFunctions = ({ track }): TrackingFunctions => ({
  trackOnContinueButtonClick: ({
    itineraryData,
    wasSelectedPrimePrice,
  }): void =>
    track(
      LABEL.trackOnContinueButtonClick({
        itineraryData,
        wasSelectedPrimePrice,
      }),
    ),
});
